
export function generateSessionId() {
    // Prefer crypto.randomUUID when available
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    // Fallback
    return `sess_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

const KEY = "app_session_id";

export function createSession() {
    const id = generateSessionId();
    sessionStorage.setItem(KEY, id);
    return id;
}

export function getSession() {
    return sessionStorage.getItem(KEY);
}

export function clearSession() {
    sessionStorage.removeItem(KEY);
}
